import Header, { HeaderComponent } from './Header';

export { HeaderComponent };
export default Header;
